import React from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";

export default function NotFound() {
    return (
        <Card>
            <CardContent>
                <Grid container
                      alignItems={"center"}
                      justifyContent={"center"}
                >
                    <Grid item>
                        <Typography variant={"h3"}>Sorry, page not found!</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}